export default "__VITE_ASSET__3272de49__"